import React from 'react';
import HeroSection from './HeroSection';
import ServicesOverview from './ServicesOverview';
import ProductsSection from './ProductsSection';
import Testimonials from './Testimonials';
import CTABanner from './CTABanner';
import SEOForWebsite from './SEOForWebsite';

const HomePage: React.FC = () => {
  return (
    <>
      <SEOForWebsite 
        title="ImpactQuill - Email Deliverability Solutions"
        description="Expert email deliverability solutions for businesses of all sizes. Protect your domain reputation, boost deliverability, and transform your email marketing."
        keywords="email deliverability, email marketing, domain reputation, email audit, SPF, DKIM, DMARC"
        canonical="/"
      />
      <HeroSection />
      <ServicesOverview />
      <ProductsSection />
      <Testimonials />
      <CTABanner />
    </>
  );
};

export default HomePage; 